import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { fmtEur } from "@/lib/format";

export default function PortalPaid() {
  const navigate = useNavigate();
  const [state, setState] = useState("checking");
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setState("failed"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/portal/pay/status/${sid}`);
        setAmount(r.data.amount || 0);
        if (r.data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(r.data.payment_status)) { setState("failed"); return; }
      } catch { /* keep polling */ }
      if (++tries < 8) setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-[#F7F5EF] flex items-center justify-center px-4">
      <Card className="p-8 text-center max-w-md w-full" data-testid="portal-paid">
        {state === "checking" && <><Loader2 className="h-10 w-10 text-[#C9A227] mx-auto mb-3 animate-spin" /><h1 className="font-heading text-xl font-bold text-slate-900">Betaling controleren…</h1><p className="text-slate-500 mt-1 text-sm">Een moment geduld.</p></>}
        {state === "paid" && <><CheckCircle2 className="h-12 w-12 text-[#C9A227] mx-auto mb-3" data-testid="portal-paid-ok" /><h1 className="font-heading text-xl font-bold text-slate-900">Betaling geslaagd</h1><p className="text-slate-500 mt-1 text-sm">Bedankt! Uw betaling{amount ? ` van ${fmtEur(amount)}` : ""} is verwerkt en verschijnt in uw overzicht.</p></>}
        {state === "pending" && <><Loader2 className="h-10 w-10 text-amber-500 mx-auto mb-3" /><h1 className="font-heading text-xl font-bold text-slate-900">Betaling in verwerking</h1><p className="text-slate-500 mt-1 text-sm">Uw iDEAL-betaling wordt verwerkt. Zodra deze binnen is, ziet u dit in uw overzicht.</p></>}
        {state === "failed" && <><XCircle className="h-12 w-12 text-red-500 mx-auto mb-3" /><h1 className="font-heading text-xl font-bold text-slate-900">Betaling niet voltooid</h1><p className="text-slate-500 mt-1 text-sm">Er is niets afgeschreven. U kunt het opnieuw proberen vanuit uw overzicht.</p></>}
        <Button className="mt-5 bg-[#0F1E3D] hover:bg-[#1B2D52] text-white" onClick={() => navigate("/portaal/overzicht", { replace: true })} data-testid="portal-paid-back">Terug naar overzicht</Button>
      </Card>
    </div>
  );
}
